__turbopack_context__.v({
  "shimmer": "Skeleton-module-scss-module__lzvviG__shimmer",
  "skeleton": "Skeleton-module-scss-module__lzvviG__skeleton",
});
